document.addEventListener('DOMContentLoaded', function(){
  
  requirejs([
    'common/components/axios', 
    'common/components/accordion', 
    'vendor/awesomplete', 
    'common/util.dom',
    'common/components/mask-phone',
    'common/components/pagination'
  ],
    function (axios, accordion, Awesomplete, utilDom, mask, pagination) {
      accordion.run();
      
      mask(".phone-format");

      new Awesomplete('input[name=tags][data-multiple]', { // eslint-disable-line no-new
        filter: function (text, input) {
          return Awesomplete.FILTER_CONTAINS(text, input.match(/[^,]*$/)[0]);
        },

        item: function (text, input) {
          return Awesomplete.ITEM(text, input.match(/[^,]*$/)[0]);
        },

        replace: function (text) {
          var before = this.input.value.match(/^.+,\s*|/)[0];
          this.input.value = before + text + "";
        }
      });

      document.querySelector('.show-form').addEventListener('click', function (e) {
        document.querySelector('.form-send-question').style.display = 'block';
      }); 

      function getTags() {
        var form = document.querySelector('form.tag-search');

        var tags = form.querySelector('input[name=tags]').value;

        axios.get(`/api/faleconosco/faqsearchbytags?tags=${tags}`)
          .then(function (response) {
            window.localStorage.setItem('lastTags', tags);
            if (response.data.length) {
              var questionContainer = document.querySelector('.question-container');
              questionContainer.innerHTML = '';
              questionContainer.appendChild(createQuestionsElements(response));              

              pagination(document.querySelector(".accordion").parentNode, 10, document.querySelector(".pagination"))

              accordion.run();
            } else {
              creciAlert.addAlert('', 'Nenhuma pergunta/resposta foi encontrada para os assuntos escolhidos', 'info');
            }
            document.querySelector('.questions-wrapper').style.display = 'block';
          })
          .catch(function () {
            creciAlert.addAlert('Erro', 'Houve um erro ao buscar perguntas', 'danger');
          });
      }

      document.querySelector('form.tag-search').addEventListener('submit', function (e) {
        e.preventDefault();
        getTags();

        return false;
      });      

      if (document.querySelector('form input[name=tags]').dataset.invalid === "False") {
        document.querySelector('form input[name=tags]').value = window.localStorage.getItem('lastTags');
        getTags();
      }

      function createQuestionsElements(response) {
        var fragment = document.createDocumentFragment();

        response.data.forEach(function (question) {
          var accordion = utilDom.createElement('div', 'accordion');

          var accordionTitle = utilDom.createElementInnerHtml('div', 'title', question.title);

          var accordionContent = utilDom.createElementInnerHtml('div', 'content', question.content);

          accordion.appendChild(accordionTitle);
          accordion.appendChild(accordionContent);

          fragment.appendChild(accordion);
        });
        return fragment;
      }
    });
});
